/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyRules } from '../../models/company-rules';

export interface UpdateCompanyEmployeeAccessRules$Json$Params {
  companyId: string;
      body?: CompanyRules
}

export function updateCompanyEmployeeAccessRules$Json(http: HttpClient, rootUrl: string, params: UpdateCompanyEmployeeAccessRules$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyRules>> {
  const rb = new RequestBuilder(rootUrl, updateCompanyEmployeeAccessRules$Json.PATH, 'patch');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyRules>;
    })
  );
}

updateCompanyEmployeeAccessRules$Json.PATH = '/company/{companyId}/rules';
